"use strict";
/**
 * @file 入口文件
 * @author hedongran
 * @email hdr01@126.com
 */
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
require("./baiduTongji");
// Map 地图核心
var Map_1 = require("./Map/Map");
Object.defineProperty(exports, "Map", { enumerable: true, get: function () { return Map_1.default; } });
var MapApiLoaderHOC_1 = require("./Map/MapApiLoaderHOC");
Object.defineProperty(exports, "MapApiLoaderHOC", { enumerable: true, get: function () { return MapApiLoaderHOC_1.default; } });
// Control 地图控件
var MapTypeControl_1 = require("./Control/MapTypeControl");
Object.defineProperty(exports, "MapTypeControl", { enumerable: true, get: function () { return MapTypeControl_1.default; } });
var ScaleControl_1 = require("./Control/ScaleControl");
Object.defineProperty(exports, "ScaleControl", { enumerable: true, get: function () { return ScaleControl_1.default; } });
var ZoomControl_1 = require("./Control/ZoomControl");
Object.defineProperty(exports, "ZoomControl", { enumerable: true, get: function () { return ZoomControl_1.default; } });
var NavigationControl_1 = require("./Control/NavigationControl");
Object.defineProperty(exports, "NavigationControl", { enumerable: true, get: function () { return NavigationControl_1.default; } });
var CityListControl_1 = require("./Control/CityListControl");
Object.defineProperty(exports, "CityListControl", { enumerable: true, get: function () { return CityListControl_1.default; } });
var PanoramaControl_1 = require("./Control/PanoramaControl");
Object.defineProperty(exports, "PanoramaControl", { enumerable: true, get: function () { return PanoramaControl_1.default; } });
// Overlay 覆盖物组件
var Marker_1 = require("./Overlay/Marker");
Object.defineProperty(exports, "Marker", { enumerable: true, get: function () { return Marker_1.default; } });
var Polyline_1 = require("./Overlay/Polyline");
Object.defineProperty(exports, "Polyline", { enumerable: true, get: function () { return Polyline_1.default; } });
var Polygon_1 = require("./Overlay/Polygon");
Object.defineProperty(exports, "Polygon", { enumerable: true, get: function () { return Polygon_1.default; } });
var Circle_1 = require("./Overlay/Circle");
Object.defineProperty(exports, "Circle", { enumerable: true, get: function () { return Circle_1.default; } });
var InfoWindow_1 = require("./Overlay/InfoWindow");
Object.defineProperty(exports, "InfoWindow", { enumerable: true, get: function () { return InfoWindow_1.default; } });
var Label_1 = require("./Overlay/Label");
Object.defineProperty(exports, "Label", { enumerable: true, get: function () { return Label_1.default; } });
var CustomOverlay_1 = require("./Overlay/CustomOverlay");
Object.defineProperty(exports, "CustomOverlay", { enumerable: true, get: function () { return CustomOverlay_1.default; } });
// Layer 图层组件
var MapvglView_1 = require("./Layer/MapvglView");
Object.defineProperty(exports, "MapvglView", { enumerable: true, get: function () { return MapvglView_1.default; } });
var MapvglLayer_1 = require("./Layer/MapvglLayer");
Object.defineProperty(exports, "MapvglLayer", { enumerable: true, get: function () { return MapvglLayer_1.default; } });
var TrafficLayer_1 = require("./Layer/TrafficLayer");
Object.defineProperty(exports, "TrafficLayer", { enumerable: true, get: function () { return TrafficLayer_1.default; } });
var PanoramaLayer_1 = require("./Layer/PanoramaLayer");
Object.defineProperty(exports, "PanoramaLayer", { enumerable: true, get: function () { return PanoramaLayer_1.default; } });
// Library 开源工具库
var DrawingManager_1 = require("./Library/DrawingManager");
Object.defineProperty(exports, "DrawingManager", { enumerable: true, get: function () { return DrawingManager_1.default; } });
var DistanceTool_1 = require("./Library/DistanceTool");
Object.defineProperty(exports, "DistanceTool", { enumerable: true, get: function () { return DistanceTool_1.default; } });
// Service 地图服务
var AutoComplete_1 = require("./Services/AutoComplete");
Object.defineProperty(exports, "AutoComplete", { enumerable: true, get: function () { return AutoComplete_1.default; } });
// Custom 自定义复杂组件
var Arc_1 = require("./Custom/Arc");
Object.defineProperty(exports, "Arc", { enumerable: true, get: function () { return Arc_1.default; } });
// 其他
// @ts-ignore
exports.mapvgl = tslib_1.__importStar(require("mapvgl"));
tslib_1.__exportStar(require("./utils"), exports);
